<template>
  <FormModal v-model="show" :title="title" :loading="loading" @submit="submit">
    <v-row>
      <v-col cols="12">
        <p v-if="text">{{ text }}</p>
      </v-col>
    </v-row>
    <v-btn
      slot="actions"
      color="red"
      dark
      :loading="loading"
      data-testid="confirmation-modal-primary-button"
      type="submit"
      >{{ actionLabel }}</v-btn
    >
    <template #activator="props">
      <slot v-bind="props" name="activator" />
    </template>
  </FormModal>
</template>

<script>
export default {
  name: 'DeleteConfirmationModal',
  props: {
    object: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default() {
        return this.$t('Remove', { title: this.object.title })
      },
    },
    text: {
      type: String,
      default: null,
    },
    actionLabel: {
      type: String,
      default() {
        return this.$t('Remove')
      },
    },
    successMessage: {
      type: String,
      default() {
        return this.$t('removeSuccess')
      },
    },
    errorMessage: {
      type: String,
      default() {
        return this.$t('removeError')
      },
    },
    onDelete: {
      type: Function,
      default(object) {
        return object.destroy()
      },
    },
  },
  data() {
    return {
      loading: false,
      show: false,
    }
  },
  methods: {
    async submit() {
      this.loading = true

      this.show = false
      try {
        await this.onDelete(this.object)
        this.notifySuccess(this.successMessage)
      } catch (error) {
        if (error.response && error.response.data) {
          this.notifyError(error.response.data.text ? error.response.data.text : error.response.data[0])
        } else if (this.errorMessage) {
          this.notifyError(this.errorMessage)
          throw error
        } else {
          throw error
        }
      } finally {
        this.loading = false
      }
    },
    open() {
      this.show = true
    },
  },
}
</script>
